import { render, staticRenderFns } from "./HBJYRHNI.vue?vue&type=template&id=2b53e8bf&scoped=true"
import script from "./HBJYRHNI.vue?vue&type=script&lang=js"
export * from "./HBJYRHNI.vue?vue&type=script&lang=js"
import style0 from "./HBJYRHNI.vue?vue&type=style&index=0&id=2b53e8bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53e8bf",
  null
  
)

export default component.exports